import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

export function TargetBlankMarker() {
	return (
		<span className='ml-0.5 inline-block -translate-y-[1.5px] text-sm'>
			<ArrowOutwardIcon className='stroke-current stroke-1' />
		</span>
	);
}
